declare namespace $ {

	type $mol_link__title_bog_ui_breadcrumb_1 = $mol_type_enforce<
		ReturnType< $bog_ui_breadcrumb['crumb_title'] >
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_link__uri_bog_ui_breadcrumb_2 = $mol_type_enforce<
		ReturnType< $bog_ui_breadcrumb['crumb_uri'] >
		,
		ReturnType< $mol_link['uri'] >
	>
	type $mol_view__sub_bog_ui_breadcrumb_3 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_ui_breadcrumb_4 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $bog_ui_breadcrumb extends $mol_view {
		last_title( ): string
		items( ): readonly(any)[]
		crumbs( ): readonly(any)[]
		crumb_title( id: any): string
		crumb_uri( id: any): string
		Crumb( id: any): $mol_link
		Sep( id: any): $mol_view
		Last( ): $mol_view
		sub( ): ReturnType< $bog_ui_breadcrumb['items'] >
	}
	
}

//# sourceMappingURL=breadcrumb.view.tree.d.ts.map